
import { Button, Col, Form, Image, Input, message, Modal, Popover, Row, Select, Space, Table, Tabs } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/CameraList.css';
const { confirm } = Modal;
const { Option } = Select;



function AdlList(props) {

  const [keyword, setKeyword] = useState('')
  const [type, setType] = useState('all')
  const [list, setList] = useState([])
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });

  useEffect(() => {
    getList(1)
  }, [type, keyword])

  //获取列表
  const getList = (currentPage) => {
    const key = 'getList';

    message.loading({ content: '加载数据...', key });
    axios({
      method: 'post',
      url: servicePath.queryIdleList,
      withCredentials: true,
      data: {
        keyword: keyword,
        type: type,
        page: currentPage ? currentPage : (tableParams.pagination?.current || 1)
      },

      header: { 'Access-Control-Allow-Origin': '*' }
    }).then(
      res => {
        if (res.data.code == 1) {
          let respData = res.data?.data || {}
          setList(respData?.list || [])

          setTableParams({
            ...tableParams,
            pagination: {
              current: respData?.currentPage || 1,
              pageSize: 20,
              total: respData?.totalCount || 0,
            },
          });
          message.success({ content: '加载数据成功！', key, duration: 2 });
        } else {
          setList([])
          message.error({ content: '加载数据失败！', key, duration: 2 });
        }
      }
    ).catch((res) => {
      setList([])
      message.error({ content: '加载数据失败！', key, duration: 2 });
    })
  }
  useEffect(() => {
    getList(1)
  }, [])

  const handleTableChange = (
    pagination
  ) => {
    setTableParams({
      pagination
    });
    getList(pagination.current)
  };

  //删除
  const deleteAdInfo = (id) => {
    confirm({
      title: '确定要删除该信息吗?',
      content: '如果你点击OK按钮，将会永远被删除，无法恢复。',
      onOk() {
        axios({
          url: servicePath.deleteIdle,
          method: 'post',
          data: {
            idId: id,
            isShow: 0
          },
          withCredentials: true,
          header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
          res => {
            message.success('删除成功')
            getList()
          }
        )
      },
      onCancel() {
        message.info('取消删除')
      },
    });

  }
  //修改
  const editAdInfo = (id, checked) => {
    props.history.push('/ad/editAd/' + id)
  }

  const onChangeTabs = (key) => {
    console.log(key);
    setType(key)
    // getList(1)
  };
  // 定义列配置
  const columns = [
    { title: 'ID', dataIndex: 'idId', key: 'idId' },
    {
      title: '标题',
      dataIndex: 'contentData',
      key: 'contentData',
      render: text => (
        <Popover content={text}>
          {text.length > 30 ? `${text.substring(0, 30)}...` : text}
        </Popover>
      )
    },
    { title: '城市', dataIndex: 'city', key: 'city' },
    {
      title: '图片',
      dataIndex: 'images',
      key: 'images',
      render: images => {
        let formattedUrl = images || "[]"
        if (formattedUrl.length > 2) {
          // 如果formattedUrl 第一个和最后个字符是'（单引号）直接转成 " （双引号
          formattedUrl = formattedUrl[0] == '"' ? "'" + formattedUrl.slice(1, -1) + "'" : formattedUrl;
          console.log(formattedUrl);
        }
        const imageArray = JSON.parse(formattedUrl);

        return (
          <>
            {imageArray?.map((url, index) => (
              <>
                <Image
                  style={{ marginRight: '5px' }}
                  width={'auto'}
                  height={'60px'}
                  src={servicePath.serverUrl + url}
                />
                {/* <img key={index} style={{ width: '60px', height: 'auto' }} src={servicePath.serverUrl + url} alt='banner图' /> */}
              </>
            ))}
          </>

        )
      }
    },
    { title: '类型', dataIndex: 'type', key: 'type' },
    { title: '价格', dataIndex: 'money', key: 'money', render: money => <div style={{ color: 'red', fontWeight: 'bold' }} >{money}</div> },
    { title: '微信', dataIndex: 'wechat', key: 'wechat' },
    { title: '发布用户', dataIndex: 'username', key: 'username' },
    { title: '发布时间', dataIndex: 'updated_at', key: 'updated_at' },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: '150px',
      render: (text, record) => (
        <Space size="middle">
          <Button onClick={() => { deleteAdInfo(record.idId) }}>删除</Button>
        </Space>
      )
    }
  ];

  const tabList = [
    {
      label: '全部',
      key: 'all'
    },
    {
      label: '冲浪板',
      key: 1
    },
    {
      label: '服饰',
      key: 2
    },
    {
      label: '冲浪周边',
      key: 3
    },
    {
      label: '其他',
      key: 4
    },
    // {
    //   label: '我发布的',
    //   key: 5
    // }
  ];


  const [form] = Form.useForm();
  // const onGenderChange = (value) => {
  //   switch (value) {
  //     case 'male':
  //       form.setFieldsValue({
  //         note: 'Hi, man!',
  //       });
  //       break;
  //     case 'female':
  //       form.setFieldsValue({
  //         note: 'Hi, lady!',
  //       });
  //       break;
  //     case 'other':
  //       form.setFieldsValue({
  //         note: 'Hi there!',
  //       });
  //       break;
  //     default:
  //   }
  // };
  const onFinish = (values) => {
    console.log(values);
    setKeyword(values?.keyword || '')
  };
  const onReset = () => {
    form.resetFields();
  };
  const onFill = () => {
    // form.setFieldsValue({
    //   note: 'Hello world!',
    //   gender: 'male',
    // });
  };
  return (
    <div>

      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{
          maxWidth: '100%',
        }}
      >
        <Row gutter={16}>
          <Col className="gutter-row" span={16}>
            <Form.Item
              name="keyword"
              label="搜索关键词"
            // rules={[
            //   {
            //     required: true,
            //   },
            // ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={6}>
            <Form.Item >
              <Space>
                <Button type="primary" htmlType="submit">
                  搜索
                </Button>
                {/* <Button htmlType="button" onClick={onReset}>
              Reset
            </Button> */}

              </Space>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={24}>
            <Tabs defaultActiveKey="all" onChange={onChangeTabs}>
              {tabList.map(tab => (
                <Tabs.TabPane tab={tab.label} key={tab.key}>
                  {tab.content}
                </Tabs.TabPane>
              ))}
            </Tabs>


          </Col>
        </Row>
      </Form>


      <Table dataSource={list} bordered columns={columns} onChange={handleTableChange} pagination={tableParams.pagination} />
    </div>
  )

}

export default AdlList